export default "__VITE_ASSET__RtfjQJpk__"